import { PARAMETRES_AFFIXE2 } from '@/configuration/paramsAffixe2';
import { getUser, login } from '@/api/login/index';
import * as allTypes from '../mutation-type';
import * as types from './user-mutation-type';
import { resetState } from '../store';

function initialState() {
  return {
    security: { isLogged: false },
    site: '',
    isClick: false,
    userId: '',
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.LOG_IN](state, user) {
    state.security = { isLogged: true, ...user };
  },
  [types.SET_USER](state, user) {
    state.user = user;
  },
  [types.LOG_OUT](state) {
    state.security = { isLogged: false };
    state.user = {};
    resetState();
  },
  [types.SET_SITE](state, site) {
    state.site = site;
  },
  [types.SET_IS_CLICK](state, isClick) {
    state.isClick = isClick;
  },
  [types.SET_USER_ID](state, userId) {
    state.userId = userId;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  logIn: async ({ getters, commit, dispatch }, payload) => {
    // eslint-disable-next-line no-useless-catch
    try {
      const response = await login(payload.site, payload.email, payload.password);
      if (payload.site !== getters.site || payload.email !== getters.userEmail) {
        resetState();
        commit(types.SET_SITE, payload.site);
        commit(types.SET_USER_ID, payload.email);
      }
      commit(types.LOG_IN, response.data);
      const response2 = await getUser(payload.email);
      commit(types.SET_USER, response2.data);
      await dispatch('parametrage/loadParamAffixe2', PARAMETRES_AFFIXE2.listeAlpha2CodePaysLimiteAutocompleteGoogle.key, { root: true });
    } catch (error) {
      throw error;
    }
  },
  logOut: ({ commit }) => {
    return new Promise((resolve) => {
      commit(types.LOG_OUT);
      resolve();
    });
  },
};

const getters = {
  accessToken: state => {
    return state.security.access_token;
  },
  refreshToken: state => {
    return state.security.refresh_token;
  },
  isLogged: state => {
    return state.security.isLogged;
  },
  userEmail: state => {
    if (state.user === undefined) return '';
    return state.user.email;
  },
  site: state => {
    return state.site;
  },
  userId: state => {
    if (state.user === undefined) return '';
    return state.userId;
  },
  userCode: state => {
    if (state.user === undefined) return '';
    return state.user.code;
  },
  idSociete: state => {
    if (state.user === undefined) return '';
    return state.user.socCode;
  },
  agenceId: state => {
    if (state.user === undefined) return '';
    return state.user.agenceId;
  },
  getIsClick: state => {
    return state.isClick;
  },
  user: state => {
    return state.user;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
